export default __webpack_public_path__ + "static/media/img_chart.b49b6688.png";